import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})

export class DataShareService {
  sharingData = new Subject<any>()
  constructor() {}
}
